<template>
<!-- 眼健康档案-新建 -->
    <div class="content">
        <div class="title">个人信息</div>
        <div class="data_content">
            <p>
                <span>姓名</span>
                <span>{{ myfiles.myfilename }}</span>
            </p>
            <p>
                <span>性别</span>
                <span>{{ myfiles.myfilesex == 0 ? '女' : '男' }}</span>
            </p>
            <p>
                <span>年龄</span>
                <span>{{ myfiles.myfileage}}</span>
            </p>
        </div>
        <div class="select_device">
            <div class="title"><img src="../assets/icon_xinghao@2x.png">选择设备</div>
            <div class="data_content">
                <p>
                    <span>设备编号</span>
                    <select class="selectBig" name="public-choice" v-model="dataId">
                        <option v-for="coupon in dataList" :key="coupon.index">{{coupon.value}}</option>
                    </select>
                </p>
            </div>
        </div>
        <div class="data_sources">
            <div class="title"><img src="../assets/icon_xinghao@2x.png">数据来源</div>
            <div class="data_content">
                <p>
                    <select class="selectBig" name="public-choice" v-model="comefromid">
                        <option v-for="coupon in comefromList" :key="coupon.index">{{coupon.value}}</option>
                    </select>
                    <span><input class="comefrom_input" type="text" v-model="comefromcontext"><img class="comefrom_img" src="../assets/icon_yellowpen@2x.png"></span>
                </p>
            </div>
        </div>
        <!-- 视力检查 -->
        <div class="visual_examination">
            <div class="title">视力检查</div>
            <div class="data_content table_content">
                <table border="1" frame="void" rules="all" class="table_eye" cellpadding="20">
                    <tr>
                        <th>眼别</th>
                        <th>裸眼视力<img class="must_fill" src="../assets/icon_xinghao@2x.png"></th>
                        <th>矫正视力<img class="must_fill" src="../assets/icon_xinghao@2x.png"></th>
                        <th>球镜</th>
                        <th>柱镜</th>
                        <th>轴位</th>
                    </tr>
                    <tr>
                        <td class="no_boder">当前左眼</td>
                        <td>
                            <span class="eyeSelect" @click="showPopup"> {{ leftLuoYanId }} </span>
                        </td>
                        <td>
                            <span class="eyeSelect" @click="left_jiaozheng"> {{ left_jiaozheng_id }} </span>
                        </td>
                        <td>
                            <input class="eye_input" v-model="leftqiujing" maxlength="5" type="text">
                        </td>
                        <td>
                            <input class="eye_input" v-model="leftzhujing" maxlength="5" type="text">
                        </td>
                        <td>
                            <input class="eye_input" v-model="leftzhouwei" maxlength="5" type="text">
                        </td>
                    </tr>
                    <tr>
                        <td class="no_boder">当前右眼</td>
                        <td>
                            <span class="eyeSelect" @click="rightShow"> {{ rightLuoYanId }} </span>
                        </td>
                        <td>
                            <span class="eyeSelect" @click="right_jiaozheng"> {{ right_jiaozheng_id }} </span>
                        </td>
                        <td>
                            <input class="eye_input" v-model="rightqiujing" maxlength="5" type="text">
                        </td>
                        <td>
                            <input class="eye_input" v-model="rightzhujing" maxlength="5" type="text">
                        </td>
                        <td>
                            <input class="eye_input" v-model="rightzhouwei" maxlength="5" type="text">
                        </td>
                    </tr>
<!--                    <tr class="yellow">
                        <td class="no_boder"><span>上次左眼</span></td>
                        <td>
                            <span>{{lastleft[1]}}</span>
                        </td>
                        <td>
                            <span>{{lastleft[0]}}</span>
                        </td>
                        <td>
                            <span>{{lastleft[2]}}</span>
                        </td>
                        <td>
                            <span>{{lastleft[3]}}</span>
                        </td>
                        <td>
                            <span>{{lastleft[4]}}</span>
                        </td>
                    </tr>
                    <tr class="yellow">
                        <td class="no_boder"><span>上次右眼</span></td>
                        <td>
                            <span>{{lastright[1]}}</span>
                        </td>
                        <td>
                            <span>{{lastright[0]}}</span>
                        </td>
                        <td>
                            <span>{{lastright[2]}}</span>
                        </td>
                        <td>
                            <span>{{lastright[3]}}</span>
                        </td>
                        <td>
                            <span>{{lastright[4]}}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="no_boder">度数差-左</td>
                        <td>
                            <span>{{left_differ[1]}}</span>
                        </td>
                        <td>
                            <span>{{left_differ[0]}}</span>
                        </td>
                        <td>
                            <span>{{left_differ[2]}}</span>
                        </td>
                        <td>
                            <span>{{left_differ[3]}}</span>
                        </td>
                        <td>
                            <span>{{left_differ[4]}}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="no_boder">度数差-右</td>
                        <td>
                            <span>{{right_differ[1]}}</span>
                        </td>
                        <td>
                            <span>{{right_differ[0]}}</span>
                        </td>
                        <td>
                            <span>{{right_differ[2]}}</span>
                        </td>
                        <td>
                            <span>{{right_differ[3]}}</span>
                        </td>
                        <td>
                            <span>{{right_differ[4]}}</span>
                        </td>
                    </tr>-->
                </table>
                <div class="tips">
                    <p class="tips_p">友情提示</p>
                    <span>左眼：</span><input class="tips_input" type="text" maxlength="10" v-model="left_tips">
                    <span >右眼：</span><input class="tips_input" type="text" maxlength="10" v-model="right_tips">
                </div>
            </div>
        </div>

        <!-- 眼健康状况调查 -->
        <div class="eye_health">
            <div class="title"><img class="eye_health_img" src="../assets/icon_xinghao@2x.png">眼健康状况调查</div>
            <div class="data_content">
                <van-checkbox-group v-model="eye_health_result">
                    <van-checkbox checked-color="#eac645" name="yangan">眼干</van-checkbox>
                    <van-checkbox checked-color="#eac645" name="suanse">眼部酸涩</van-checkbox>
                    <van-checkbox checked-color="#eac645" name="zhangtong">眼部胀痛</van-checkbox>
                    <van-checkbox checked-color="#eac645" name="liulei">眼部流泪</van-checkbox>
                    <van-checkbox checked-color="#eac645" name="shuimian">睡眠质量（差）</van-checkbox>
                    <van-checkbox checked-color="#eac645" name="touteng">头疼</van-checkbox>
                    <van-checkbox checked-color="#eac645" name="yanquan">黑眼圈</van-checkbox>
                    <van-checkbox checked-color="#eac645" name="yandai">眼袋</van-checkbox>
                    <van-checkbox checked-color="#eac645" name="fuzhong">眼部浮肿</van-checkbox>
                </van-checkbox-group>
            </div>
        </div>

        <!-- 其他 -->
        <div class="describe">
            <div class="title">其他眼部情况？请您详细描述</div>
            <div class="textarea_div">
                <textarea class="textarea" v-model="describe" rows="5" cols="40" maxlength="500" placeholder="请输入您的详细描述(最多500字)"></textarea>
            </div>
        </div>

        <!-- 提交按钮 -->
        <div class="data_content">
            <button @click="submit" class="submit">确认</button>
        </div>

        <!-- 当前左眼弹出层 -->
        <van-popup v-model="show">
            <van-radio-group @change="change" :max="1" v-model="leftLuoYanId">
                <van-radio v-for="item in leftLuoYanList" :key="item.index"  checked-color="#eac645" :name="item.value">{{ item.value }}</van-radio>
            </van-radio-group>
        </van-popup>

        <!-- 矫正左眼弹出层 -->
        <van-popup v-model="left_jiaozheng_show">
            <van-radio-group @change="left_jz_change" :max="1" v-model="left_jiaozheng_id">
                <van-radio v-for="item in left_jiaozheng_list" :key="item.index"  checked-color="#eac645" :name="item.value">{{ item.value }}</van-radio>
            </van-radio-group>
        </van-popup>

        <!-- 当前右眼弹出层 -->
        <van-popup v-model="right_show">
            <van-radio-group @change="right_change" :max="1" v-model="rightLuoYanId">
                <van-radio v-for="item in rightLuoYanList" :key="item.index"  checked-color="#eac645" :name="item.value">{{ item.value }}</van-radio>
            </van-radio-group>
        </van-popup>

        <!-- 矫正右眼弹出层 -->
        <van-popup v-model="right_jiaozheng_show">
            <van-radio-group @change="right_jz_change" :max="1" v-model="right_jiaozheng_id">
                <van-radio v-for="item in right_jiaozheng_list" :key="item.index"  checked-color="#eac645" :name="item.value">{{ item.value }}</van-radio>
            </van-radio-group>
        </van-popup>
    </div>
</template>

<script>
import Vue from 'vue';
import { Popup } from 'vant';
import { Checkbox, CheckboxGroup } from 'vant';
import { RadioGroup, Radio } from 'vant';
import { Toast } from 'vant';

Vue.use(Toast);
Vue.use(Popup);
Vue.use(Checkbox).use(CheckboxGroup);
Vue.use(RadioGroup);
Vue.use(Radio);

export default {
    props: {

  },
    data() {
        return {
            leftcount: [],
            lastleft: [],
            rightcount: [],
            lastright: [],
            left_differ: [],
            right_differ:[],
            lastleftid: '',
            lastrightid: '',


            checked: true,


            comefromcontext: '',    //来源描述

            describe: '',       //其他描述
            leftqiujing: '0.0',    //当前左眼球镜
            leftzhujing: '0.0',    //当前左眼柱镜
            leftzhouwei: '0.0',    //当前左眼轴位
            rightqiujing: '0.0',   //当前右眼球镜
            rightzhujing: '0.0',    //当前右眼柱镜
            rightzhouwei: '0.0',    //当前右眼轴位

            eye_health_result: [],  // 眼睛情况

            left_tips: '',  // 左眼提示
            right_tips: '', // 右眼提示

            // 当前左眼
            show: false,
            leftLuoYanId: '5.2/1.5',    //当前左眼裸眼视力
            leftLuoYanList: [
                {key: 5.2, value: '5.2/1.5'},
                {key: 5.1, value: '5.1/1.2'},
                {key: 5.0, value: '5.0/1.0'},
                {key: 4.9, value: '4.9/0.8'},
                {key: 4.8, value: '4.8/0.6'},
                {key: 4.7, value: '4.7/0.5'},
                {key: 4.6, value: '4.6/0.4'},
                {key: 4.5, value: '4.5/0.3'},
                {key: 4.4, value: '4.4/0.25'},
                {key: 4.3, value: '4.3/0.2'},
                {key: 4.2, value: '4.2/0.15'},
                {key: 4.1, value: '4.1/0.12'},
                {key: 4.0, value: '4.0/0.1'},
            ],

            // 矫正左眼
            left_jiaozheng_show: false,
            left_jiaozheng_id: '5.0/1.0',
            left_jiaozheng_list: [
                {key: 5.0, value: '5.0/1.0'},
                {key: 4.9, value: '4.9/0.8'},
                {key: 4.8, value: '4.8/0.6'},
                {key: 4.7, value: '4.7/0.5'},
                {key: 4.6, value: '4.6/0.4'},
                {key: 4.5, value: '4.5/0.3'},
                {key: 4.4, value: '4.4/0.25'},
                {key: 4.3, value: '4.3/0.2'},
                {key: 4.2, value: '4.2/0.15'},
                {key: 4.1, value: '4.1/0.12'},
                {key: 4.0, value: '4.0/0.1'},
            ],

            // 当前右眼
            right_show: false,
            rightLuoYanId: '5.2/1.5',
            rightLuoYanList: [
                {key: 5.2, value: '5.2/1.5'},
                {key: 5.1, value: '5.1/1.2'},
                {key: 5.0, value: '5.0/1.0'},
                {key: 4.9, value: '4.9/0.8'},
                {key: 4.8, value: '4.8/0.6'},
                {key: 4.7, value: '4.7/0.5'},
                {key: 4.6, value: '4.6/0.4'},
                {key: 4.5, value: '4.5/0.3'},
                {key: 4.4, value: '4.4/0.25'},
                {key: 4.3, value: '4.3/0.2'},
                {key: 4.2, value: '4.2/0.15'},
                {key: 4.1, value: '4.1/0.12'},
                {key: 4.0, value: '4.0/0.1'},
            ],

            // 矫正右眼
            right_jiaozheng_show: false,
            right_jiaozheng_id: '5.0/1.0',
            right_jiaozheng_list: [
                {key: 5.0, value: '5.0/1.0'},
                {key: 4.9, value: '4.9/0.8'},
                {key: 4.8, value: '4.8/0.6'},
                {key: 4.7, value: '4.7/0.5'},
                {key: 4.6, value: '4.6/0.4'},
                {key: 4.5, value: '4.5/0.3'},
                {key: 4.4, value: '4.4/0.25'},
                {key: 4.3, value: '4.3/0.2'},
                {key: 4.2, value: '4.2/0.15'},
                {key: 4.1, value: '4.1/0.12'},
                {key: 4.0, value: '4.0/0.1'},
            ],

            //个人信息
            myfiles: {},

            // 选择数据来源
            comefromid: '',
            comefromList: [
                {key: -1, value: "请选择"},
                {key: 1, value: "眼镜店"},
                {key: 2, value: "医院检查"},
                {key: 3, value: "自查"}
            ],

            // 选择设备
            dataId: '',
            dataList: [
                {
                    key: -1, value: "请选择"
                },
                {
                    key: 1, value: "0a180096"
                }
            ],

            yangan: 'yangan',
            suanse: 'suanse',
            zhangtong: 'zhangtong',
            liulei: 'liulei',
            shuimian: 'shuimian',
            touteng: 'touteng',
            yanquan: 'yanquan',
            yandai: 'yandai',
            fuzhong: 'fuzhong'
        };
    },
    computed: {

    },

    created() {
        this.getdiffer()
        this.comefromid = this.comefromList[0].value;
        this.dataId = this.dataList[0].value;
        this.getDataList()
        this.change()
        this.right_change()
    },
    watch: {
        // 如果 `question` 发生改变，这个函数就会运行
        leftqiujing: function () {
            this.getdiffer()
        },
        leftzhujing: function() {
            this.getdiffer()
        },
        leftzhouwei: function() {
            this.getdiffer()
        },
        rightqiujing: function () {
            this.getdiffer()
        },
        rightzhujing: function() {
            this.getdiffer()
        },
        rightzhouwei: function() {
            this.getdiffer()
        },
    },
    methods: {
        submit() {
            // 处理数据来源
            let arr = [
                {
                    id: 1,
                    value: '眼镜店'
                },
                {
                   id: 2,
                    value: '医院检查'
                },
                {
                   id: 3,
                    value: '自查'
                }
            ]
            let comefromid = arr.findIndex((item)=>item.value==this.comefromid) + 1
            // let instrumentid =
            let arr1 = this.eye_health_result

            let data = {
                instrumentid: this.dataId,  //设备ID
                tishi: '左眼：'+ this.left_tips + ';右眼：' + this.right_tips, //友情提示
                myfileid: this.$route.params.myfileid,  //个人信息ID
                comefromid: comefromid, // 数据来源

                comefromcontext: this.comefromcontext,  //来源描述
                leftqiujing: this.leftqiujing,    //当前左眼球镜
                leftzhujing: this.leftzhujing,  //当前左眼柱镜
                leftzhouwei: this.leftzhouwei,  //当前左眼轴位
                leftluoyan: this.leftLuoYanId.slice(0,3),   //当前左眼裸眼视力
                leftjiaozheng: this.left_jiaozheng_id.slice(0,3),   //当前左眼矫正视力
                rightqiujing: this.rightqiujing,    //当前右眼球镜
                rightzhujing: this.rightzhujing,  //当前右眼柱镜
                rightzhouwei: this.rightzhouwei,  //当前右眼轴位
                rightluoyan: this.rightLuoYanId.slice(0,3),   //当前右眼裸眼视力
                rightjiaozheng: this.right_jiaozheng_id.slice(0,3),   //当前右眼矫正视力
                lastleftid: this.lastleftid,
                lastrightid: this.lastrightid,
                other: this.describe,
                yangan: this.yangan = arr1.indexOf('yangan') != -1 ? 1 : 0,
                suanse: this.suanse = arr1.indexOf('suanse') != -1 ? 1 : 0,
                zhangtong: this.zhangtong = arr1.indexOf('zhangtong') != -1 ? 1 : 0,
                liulei: this.liulei = arr1.indexOf('liulei') != -1 ? 1 : 0,
                shuimian: this.shuimian = arr1.indexOf('shuimian') != -1 ? 1 : 0,
                touteng: this.touteng = arr1.indexOf('touteng') != -1 ? 1 : 0,
                yanquan: this.yanquan = arr1.indexOf('yanquan') != -1 ? 1 : 0,
                yandai: this.yandai = arr1.indexOf('yandai') != -1 ? 1 : 0,
                fuzhong: this.fuzhong = arr1.indexOf('fuzhong') != -1 ? 1 : 0,
            }
            if(data.instrumentid == '请选择') {
                Toast('请选择设备噢！')
                return false
            }
            if(data.comefromid == 0) {
                Toast('请选择数据来源噢！')
                return false
            }
            this.axios.post('/weixin/addEye', data)
            .then(res=>{
                Toast('成功！');
                this.$router.push('/')
            })
        },

        // 求差
        getdiffer() {
            // 当前左
            if(!this.lastleft) {

            }

            let dq_left = []
            dq_left.push( this.left_jiaozheng_id.slice(0,3),this.leftLuoYanId.slice(0,3),this.leftqiujing,this.leftzhujing,this.leftzhouwei)
            this.left_differ = dq_left.map((val,index)=>((val - this.lastleft[index]).toFixed(2)));

            let dq_right = []
            dq_right.push( this.right_jiaozheng_id.slice(0,3),this.rightLuoYanId.slice(0,3),this.rightqiujing,this.rightzhujing,this.rightzhouwei)
            this.right_differ = dq_right.map((val,index)=>((val - this.lastleft[index]).toFixed(2)));
        },

        // 当前左眼
        showPopup() {
            this.show = true;
        },
        // 判断左眼友情提示
        change() {
            let left = this.leftLuoYanId.slice(0,3)
            if(left > 5.0) {
                this.left_tips = '视力正常'
            }
             if(left == 5.0) {
                this.left_tips = '视力边缘'
            }
             if(left == 4.9 || left < 4.9) {
                this.left_tips = '轻度视力不良'
            }
             if(left < 4.5 || left == 4.5) {
                this.left_tips = '中度视力不良'
            }
            this.show = false;
            this.getdiffer()

        },
        left_jiaozheng() {
            this.left_jiaozheng_show = true;
        },
        left_jz_change() {
            this.left_jiaozheng_show = false;
            this.getdiffer()
        },

        // 当前右眼点击
        rightShow() {
            this.right_show = true;
        },
        // 当前右眼选择度数变化
        right_change() {
            let right = this.rightLuoYanId.slice(0,3)
            if(right > 5.0) {
                this.right_tips = '视力正常'
            }
             if(right == 5.0) {
                this.right_tips = '视力边缘'
            }
             if(right == 4.9 || right < 4.9) {
                this.right_tips = '轻度视力不良'
            }
             if(right < 4.5 || right == 4.5) {
                this.right_tips = '中度视力不良'
            }
            this.right_show = false;
            this.getdiffer()

        },
        right_jiaozheng() {
            this.right_jiaozheng_show = true;
            this.getdiffer()

        },
        right_jz_change() {
            this.right_jiaozheng_show = false;
            this.getdiffer()
        },

        // 获取个人信息
        getDataList() {
            this.axios.get('/weixin/getEye', {
                params: {
                    myfileid: this.$route.params.myfileid

                }
            })
            .then(res=>{
                function fn (a) {
                let arr = []
                for (let i in a) {
                    arr.push(a[i]);
                }
                return arr.slice(1)
            }


                this.myfiles = res.data
   /*           for (let i=0;i<res.data.instrumentid.size;i++){
                this.dataList.push({key:i,value: data.instrumentid[i]});
              }*/
             //
              for(let i=0;i<res.data.instrumentid.length;i++){

             //   this.dataList[i+1].value = res.data.instrumentid[i]
                this.dataList.push({key:i,value:res.data.instrumentid[i]})
              }

               // this.dataList[1].value = res.data.instrumentid[0]
                this.lastleftid = res.data.lastleftid
                this.lastrightid = res.data.lastrightid
                let a =  fn(res.data.lastleftid)
                let b = fn(res.data.lastrightid)
                this.lastleft = a
                this.lastright = b

                this.getdiffer()
            })
        }
    },
    components: {

    },
};
</script>

<style>
.van-toast--html, .van-toast--text {
    min-width: 3.56rem;
    min-height: 50px;
}
.van-checkbox {
    height: 84px;
    line-height: 84px;
    border-bottom: 2px solid #f0f0f0;
    font-size: 34px;
    color: #333;
    letter-spacing: 4px;
}
.van-checkbox:last-child {
    border-bottom: none;
}

.van-checkbox__icon {
    height: 34px;
    line-height: 34px;

}

.van-checkbox__icon .van-icon {
    border: 2px solid #eac645;
    width: 36px;
    height: 36px;
}

.van-checkbox__label {
    line-height: normal;
}
.van-radio__icon .van-icon {
    border: 2px solid #eac645;
}

.van-radio-group {
    padding: 28px;
}

.van-popup--center {
    width: 400px;
    top: 50%;
}
.van-radio {
    height: 50px;
    margin-bottom: 20px;
}


/* .van-radio__icon--checked .van-icon {
    background-color: #eac645 !important;
    border: 2px solid #eac645 !important;
} */

.van-radio__label {

    margin-left: 40px;
}
</style>

<style scoped>
select {
    color: #333;
    /*Chrome和Firefox里面的边框是不一样的，所以复写了一下*/
    border: 2px solid #eac645;
    border-radius: 30px;
    /*很关键：将默认的select选择框样式清除*/
    appearance:none;
    -moz-appearance:none;
    -webkit-appearance:none;
    /*在选择框的最右侧中间显示小箭头图片*/
    outline:none;
}
/*清除ie的默认选择框样式清除，隐藏下拉箭头*/
select::-ms-expand { display: none; }

.selectBig {
    width: 300px;
    height: 54px;
    font-size: 38px;
    background: url("../assets/icon_qingxuanze@2x.png") no-repeat scroll right center transparent;
    background-position-x: 260px;
    background-size: 24px;
    padding-right: 60px;
    padding-left: 12px;
}

.eyeSelect {
    text-align:left;
    font-size: 28px;
    display: inline-block;
    border: 2px solid #eac645;
    border-radius: 30px;
    margin: 18px 6px;
    width: 148px;
    height: 42px;
    line-height: 42px;
    background: url("../assets/icon_shili@2x.png") no-repeat scroll right center transparent;
    background-position-x: 136px;
    background-size: 18px;
    padding-left: 10px;
}


td, th {
    text-align: center;
    line-height: 82px;
}

.title {
    padding: 28px;
}
.title img{
    width: 12px;
    vertical-align: top;
    padding-right: 10px;
}
.data_content {
    padding: 0 28px;
    background: #fff;
}

.data_content p {
    height: 92px;
    border-bottom: 1px solid #f0f0f0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 38px;
}

.data_content p:last-child {
    border-bottom: none;
}
.table_content {
    padding: 10px;
}

.table_eye {
    width: 100%;
    border-left: none;
}


td {
    border: none;
    border-left: 2px solid #f0f0f0;
    border-bottom: 2px solid #f0f0f0;
}

.no_boder {
    border-left: none;
}

th {
    border: none;
    border-bottom: 2px solid #f0f0f0;

}



.eye_input {
    width: 70px;
    height: 42px;
    border: none;
    text-align: center;
}

.must_fill {
    width: 10px;
    vertical-align: super;
    margin-left: 4px;
}

.yellow {
    color: #eac645;
}

.tips {
    line-height: 82px;
    font-size: 34px;
    border-top: 2px solid #f0f0f0;
}
.tips .tips_p {
    border-bottom: none;
    display: inline-block;
    height: 82px;
    padding-right: 30px;
    line-height: 82px;
}
.tips_input {
    width: 180px;
    border: none;
}

.eye_health_img {
    width: 10px;
    vertical-align: super;
    margin-right: 10px;
}

.textarea_div {
    padding: 0 28px 28px;
}

.textarea {
    resize:none;
    width: 100%;
    height: 194px;
    text-indent: 30px;
    background: #fff;
    border: none;
    border-radius: 30px;
    font-size: 32px;
    color: #333;
}
.comefrom_input {
    width: 350px;
    border: none;
}

.comefrom_img {
    width: 26px;
    margin-left: 10px;
}

.submit {
    width: 100%;
    background: #eac645;
    color: #fff;
    border-radius: 20px;
    height: 96px;
    margin-bottom: 30px;
}

.p_input {
    position: relative;
}

.span_checbox {
    display: block;
    width: 36px;
    height: 36px;
    position: absolute;
    background: #fff;
    border: 2px solid #cfcfcf;
    border-radius: 50%;
}

.span_checked {
    display: block;
    width: 36px;
    height: 36px;
    position: absolute;
    background: #eac645;
    border: 2px solid #eac645;
    content: "\2714";
    color: #fff;
    text-align: center;
    border-radius: 50%;
}

.input_text {
    font-size: 34px;
    display: inline-block;
    margin-left: 60px;
}
</style>



// WEBPACK FOOTER //
// src/views/NewFiles.vue